export const initialValues = {
    birthdate: '',
    city: '',
    customerEmail: '',
    firstName: '',
    houseNumber: '',
    houseNumberAddition: '',
    lastName: '',
    lastNamePrefix: '',
    newCity: '',
    newHouseNumber: '',
    newHouseNumberAddition: '',
    newStreet: '',
    newZipcode: '',
    phoneNumber: '',
    relocationDate: '',
    salutation: '',
    sendToDeliveryService: false,
    store: '',
    storeEmail: '',
    storeTwo: '',
    storeTwoEmail: '',
    street: '',
    termsAgreed: false,
    zipcode: '',
};
